<!--Moved to Trip-history-details component-->
<ng-template #mapPopOver>
  <div class="filter-close-container">
    <div class="d-flex align-items-center gap-10">
      <div *ngIf="sharedService.rbacManagement('entities_GeoFence')">
        <button class="geo-fence-button uni-geo-fence-bt" (click)="enableDrawControls()">{{ !showControls ? 'Geo-fence' : 'Trip
          history' }}</button>
      </div>
      <div class="cursor" (click)="geoTracePlayback()">
        <img src="../../../../assets/images/Geo-Playback.svg" alt="">
      </div>
      <div
        class="filter-drop-down period route-filter fit-content -mat-select-height-unset -border-bottom-none calendar-geo-fence"
        *ngIf="!showControls">
        <mat-form-field appearance="outline" class="mw-150 route-date-picker-alignement">
          <input matInput [matDatepicker]="dp3" placeholder="Date" [formControl]="datePicker" [readonly]="true"
            (dateChange)="dateChange($event)" [min]="minDate" [max]="maxDate">
          <mat-datepicker-toggle matSuffix [for]="dp3">
            <mat-icon matDatepickerToggleIcon>
              <img src="../../../../assets/images/icon-calendar.svg" alt="calendar" title="calendar">
            </mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #dp3 disabled="false"></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="pop-close">
        <img src="../../../../assets/images/dover-close-icon.svg" alt="close" class="h-30 cursor" title="close"
          mat-dialog-close>
      </div>
    </div>
  </div>
  <div class="make-responsive-vehicle-graphics">
    <app-leaflet-map pageType="profile" [mapData]="masterMapData" [showControls]="showControls" [popOver]="popRoute"
      class="w-100" *ngIf="popRoute" (drawZoneAction)="geoFenceValues($event)" styleType="full">
    </app-leaflet-map>
    <!-- <app-trip-history *ngIf="!showControls" [entityId]="entityId" [date]="selectedDate"></app-trip-history> -->
    <app-geo-trace-zone-details *ngIf="showControls"></app-geo-trace-zone-details>
  </div>
</ng-template>
<!--Moved to Trip-history-details component-->

<div class="tile">
  <div class="child">
    <span class="geo-trace-btn" (click)="goToTripHistory()">Geo trace &nbsp;
      <img src="../../../../assets/images/goToArrow.svg" alt="Geo trace" class="h-18 cursor" title="Geo trace">
    </span>
    <app-entity-summary [entityId]="entityId" [fromDate]="fromDate" [toDate]="toDate"></app-entity-summary>
  </div>
  <div class="background">
    <app-leaflet-map pageType="profile" [mapData]="masterMapData" class="w-100" *ngIf="!popRoute" [styleType]="widgetCount <= 2 ? (scalingClass < 125 ? 'mini-vot-map' : 'mini-vot' ): 'mini'">
    </app-leaflet-map>
  </div>
</div>